import { ICalendarEvent, IInteractiveModCalendar } from "@blings/blings-player";
import {
  CALENDAR_EXPRESSION_EXAMPLE,
  createEmptyCalendarEvent,
  parseCalendarEventValue,
} from "../../calendarConnector";

export type CalendarSourceDraft = {
  form: ICalendarEvent;
  code: string;
};

const calendarSourceDrafts = new Map<string, Partial<CalendarSourceDraft>>();

export const getCalendarSourceDraft = (
  draftKey: string,
  change: Partial<IInteractiveModCalendar>
): CalendarSourceDraft => {
  const storedDraft = calendarSourceDrafts.get(draftKey);
  return {
    form:
      parseCalendarEventValue(change.value) ||
      storedDraft?.form ||
      createEmptyCalendarEvent(),
    code: change.expression || storedDraft?.code || CALENDAR_EXPRESSION_EXAMPLE,
  };
};

export const saveCalendarSourceDraft = (
  draftKey: string,
  draft: Partial<CalendarSourceDraft>
) => {
  calendarSourceDrafts.set(draftKey, {
    ...calendarSourceDrafts.get(draftKey),
    ...draft,
  });
};

export const clearCalendarSourceDraft = (draftKey: string) => {
  calendarSourceDrafts.delete(draftKey);
};
